import React from 'react';

import {SkeletonBlock} from 'src/components/skeleton-block/skeleton-block';

import {Group} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';

import {section} from '../vendor-profile.module.styl';

export const VendorProfileSkeleton: React.FC = () => (
    <div className={section}>
        <Typography variant="heading-level-3">
            <SkeletonBlock width={180} height={24}/>
        </Typography>
        <Group direction="v" gap="m">
            <SkeletonBlock width={320} height={20}/>
            <SkeletonBlock width={260} height={20}/>
            <SkeletonBlock width={220} height={20}/>
        </Group>
    </div>
);
